const addTimeout = (promise, timeout = 30_000) => {
  const timeoutPromise = new Promise((_, reject) => {
    setTimeout(() => reject(new Error(`Request timed out`)), timeout);
  });

  return Promise.race([promise, timeoutPromise]);
};

export const getFallbackTranslations = () => addTimeout(import('../en.json'));
